(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fn-email-popup"]) return;
  try {
    
  if (!customElements.get('fn-email-popup')) {
    customElements.define('fn-email-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const close = () => this.dialog.close();
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', close, {signal}));
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) close(); }, {signal});
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          try { localStorage.setItem('fn_signup_dismissed', String(Date.now())); } catch {}
        }, {signal});
        if (location.hash.startsWith('#FnMidWaitlist-')) return;
        const success = this.querySelector('[data-signup-success]');
        if (success) {
          try { localStorage.setItem('fn_signup_complete', 'true'); } catch {}
          this.show();
          return;
        }
        if (this.querySelector('[data-signup-errors]')) { this.show(); return; }
        if (this.dataset.editor === 'true') return;
        if (/\/cart|\/policies\/|\/challenge|\/pages\/yips|\/products\/yips/.test(location.pathname)) return;
        const preview = this.dataset.themeRole !== 'main' && new URLSearchParams(location.search).get('fn_signup_preview') === '1';
        try {
          if (!preview && localStorage.getItem('fn_signup_complete') === 'true') return;
          if (!preview && Date.now() - Number(localStorage.getItem('fn_signup_dismissed')) < 7 * 86400000) return;
        } catch {}
        this.timer = setTimeout(() => this.show(), Number(this.dataset.delay));
      }
      show() {
        if (!this.isConnected || this.dialog.open) return;
        if (document.querySelector('dialog[open]')) return;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
